import { useContext } from "react";

import { CspConfigContext } from "../../contexts/user/CspConfigContext";

const useCspConfig = () => {
  const context = useContext(CspConfigContext);
  return context;
};

export default useCspConfig;
